"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const sql_1 = require("../../../@inax/sql");
let KeysPipe = class KeysPipe {
    transform(value, args) {
        let keys = [];
        for (let key in value) {
            keys.push({ key: key, value: value[key] });
        }
        return keys;
    }
};
KeysPipe = __decorate([
    core_1.Pipe({ name: 'keys' })
], KeysPipe);
exports.KeysPipe = KeysPipe;
let SqlViewerComponent = class SqlViewerComponent {
    constructor(_inaxSql) {
        this._inaxSql = _inaxSql;
        this.table = "Motions";
        this.where = "";
        this.orderby = "";
        this.include = "";
        this.groupby = "";
        this.skip = 0;
        this.take = 50;
        this.result = [];
        this.queriedData = "?";
    }
    ngOnInit() {
    }
    onExecuteQuery() {
        try {
            this.queriedData = "?";
            this._inaxSql.query(this.table, this.where, this.orderby, this.include, this.groupby, this.skip, this.take).subscribe((data) => {
                try {
                    if (data != null) {
                        this.queriedData = this.table;
                        this.result = data.Entries;
                    }
                    else {
                        console.warn("no data red!");
                    }
                }
                catch (error) {
                    console.warn("no data red!");
                }
            });
        }
        catch (error) {
            console.error(error);
        }
    }
};
SqlViewerComponent = __decorate([
    core_1.Component({
        selector: 'sql-viewer',
        templateUrl: 'app/components/sqlviewer/sqlviewer.component.html',
        styleUrls: ['app/components/sqlviewer/sqlviewer.component.css']
    }),
    __metadata("design:paramtypes", [sql_1.InaxSqlService])
], SqlViewerComponent);
exports.SqlViewerComponent = SqlViewerComponent;
